import {AmountTypeEnum} from '../../enums/amount-type.enum';

export interface RateCardDTO {
  productId: number;
  priceMin: number;
  priceMax: number;
  payableFee: number;
  feeType: AmountTypeEnum;
}
